import FetchError from './FetchError';

const stringField = (
    value: object,
    key: 'error' | 'message',
): string | null => {
    const field: unknown = Object.getOwnPropertyDescriptor(value, key)?.value;
    return typeof field === 'string' && field.trim().length > 0 ? field : null;
};

const errorMessageFromJson = (json: unknown): string | null => {
    if (typeof json !== 'object' || json === null) {
        return null;
    }

    return stringField(json, 'error') ?? stringField(json, 'message');
};

/**
 * Parse an error body that was already read as text. Non-JSON (an ALB HTML
 * page, or an empty body) yields no message so the caller can use the status.
 */
const parsedErrorBody = (bodyText: string): unknown => {
    const trimmed = bodyText.trim();
    if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
        return undefined;
    }

    try {
        return JSON.parse(trimmed) as unknown;
    } catch {
        return undefined;
    }
};

const jsonBody = (parsed: unknown): object => {
    if (typeof parsed === 'object' && parsed !== null) {
        return parsed;
    }

    if (parsed === undefined) {
        return {};
    }

    return { fallback: parsed };
};

export const fetchErrorFromResponseBody = ({
    bodyText,
    response,
    endpoint,
    method,
}: {
    bodyText: string;
    response: Response;
    endpoint: string;
    method: string;
}): FetchError => {
    const parsed = parsedErrorBody(bodyText);
    const jsonErrorMessage = errorMessageFromJson(parsed);
    const errorMessage =
        (jsonErrorMessage ?? response.statusText) || `HTTP ${response.status}`;

    return new FetchError(errorMessage, response, jsonBody(parsed), {
        endpoint,
        method,
    });
};
